import React, {type PropsWithChildren, createContext, useContext} from 'react'

type BlocksLayout = {
  isMobile: boolean
}

const BlocksLayoutContext = createContext<BlocksLayout | null>(null)

type BlocksLayoutProviderProps = PropsWithChildren<{
  value: BlocksLayout
}>

export function BlocksLayoutProvider({value, children}: BlocksLayoutProviderProps) {
  return <BlocksLayoutContext.Provider value={value}>{children}</BlocksLayoutContext.Provider>
}

export function useBlocksLayout() {
  const contextValue = useContext(BlocksLayoutContext)

  if (!contextValue) {
    throw new Error('You should wrap your blocks layout in "BlocksLayoutProvider"')
  }

  return contextValue
}
